export default {
    exportName: 'UserFormComponent',
    isDefault: true,
    key: 'GeneralInformation',
    getSections(userContext) {
        return {
            key: 'GeneralInformation',
            component: () => import('@/Fwamework/Users/Components/GeneralInformation.vue'),
            config: {
                title: userContext.data.general.id == 0 ? "" : `${userContext.data.general.firstName} ${userContext.data.general.lastName}`,
                displayPriority: 1
            }
        };
    }
};